import { render } from "./dependents-checkbox-list.vue?vue&type=template&id=f7a82674&scoped=true"
import script from "./dependents-checkbox-list.vue?vue&type=script&lang=js"
export * from "./dependents-checkbox-list.vue?vue&type=script&lang=js"

import "./dependents-checkbox-list.vue?vue&type=style&index=0&id=f7a82674&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7a82674"]])

export default __exports__